import { render, staticRenderFns } from "./pendingShopEdit.vue?vue&type=template&id=29ec2700&scoped=true"
import script from "./pendingShopEdit.vue?vue&type=script&lang=js"
export * from "./pendingShopEdit.vue?vue&type=script&lang=js"
import style0 from "./pendingShopEdit.vue?vue&type=style&index=0&id=29ec2700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ec2700",
  null
  
)

export default component.exports